import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  FreeMode,
  Pagination,
  Navigation,
  Scrollbar,
  A11y,
  Grid,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/grid";

import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

function CustomSwiper({ children, isPagination, isNavigation, ...props }) {
  const swiperRef = useRef();
  return (
    <div className={`group w-full relative`}>
      <Swiper
        style={{
          "--swiper-pagination-color": "var(--primary-color)",
          "--swiper-pagination-bullet-inactive-color": "#999999",
          "--swiper-pagination-bullet-inactive-opacity": "1",
          "--swiper-pagination-bullet-size": "16px",
          "--swiper-pagination-bullet-horizontal-gap": "6px",
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        modules={[FreeMode, Navigation, Pagination, Scrollbar, A11y, Grid]}
        pagination={{
          el: ".containerForBullets",
          clickable: true,
        }}
        navigation={{
          nextEl: ".image-swiper-button-next",
          prevEl: ".image-swiper-button-prev",
          disabledClass: "swiper-button-disabled",
        }}
        {...props}
      >
        {React.Children.map(children, (child, index) => {
          return <SwiperSlide key={index}>{child}</SwiperSlide>;
        })}
        <div className='flex justify-center items-center select-none mt-10'>
          {isNavigation && (
            <div className='image-swiper-button-prev w-8 h-8 rounded-full bg-primary cursor-pointer flex items-center justify-center text-white text-xl mx-2'>
              <IoIosArrowBack />
            </div>
          )}
          {isPagination && (
            <div
              className='containerForBullets flex justify-center items-center gap-2'
            ></div>
          )}
          {isNavigation && (
            <div className='image-swiper-button-next w-8 h-8 rounded-full bg-primary cursor-pointer flex items-center justify-center text-white text-xl mx-2'>
              <IoIosArrowForward />
            </div>
          )}
        </div>
      </Swiper>
    </div>
  );
}

export default CustomSwiper;
